"use client";

import { useEffect } from "react";
import { logger } from "@/lib/error-logger";
import CanonHeading from "@/components/atoms/Heading/Heading";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    const pathname =
      typeof window !== "undefined" ? window.location.pathname : undefined;

    logger.reportBoundaryError(error, {
      boundary: "global",
      routeArea: "global",
      pathname,
      digest: error.digest,
      component: "app/global-error",
    });
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ padding: "2rem", fontFamily: "system-ui" }}>
          <CanonHeading level={1}>Something went wrong</CanonHeading>
          <p>{error.message}</p>
          <button onClick={() => reset()}>Try again</button>
        </div>
      </body>
    </html>
  );
}
